module.exports = __webpack_public_path__ + "static/fonts/NotoSans-DemiLight.53abcd8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-DemiLight.eot?
// module id = vhu+
// module chunks = 0